(function () {
  if (window.CustomUpsellsInitialized) return;
  window.CustomUpsellsInitialized = true;

  var cartRefreshTimer = null;

  function getShopRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || "/").replace(/\/?$/, "/");
  }

  function parseJson(root, selector) {
    var script = root.querySelector(selector);
    if (!script) return [];

    try {
      var parsed = JSON.parse(script.textContent || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function uniqueIds(ids) {
    return ids.filter(function (id, index) {
      return id && ids.indexOf(id) === index;
    });
  }

  function escapeHtml(value) {
    var div = document.createElement("div");
    div.textContent = value == null ? "" : String(value);
    return div.innerHTML;
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/`/g, "&#96;");
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents || 0, format);
    }

    return ((Number(cents) || 0) / 100).toFixed(2);
  }

  function fetchCart() {
    return fetch(getShopRoot() + "cart.js", {
      credentials: "same-origin",
      cache: "no-store"
    }).then(function (response) {
      return response.ok ? response.json() : { items: [] };
    }).catch(function () {
      return { items: [] };
    });
  }

  function fetchRecommendations(productIds, intent, limit) {
    var requestLimit = Math.min(Math.max(limit * 3, limit), 10);
    var requests = uniqueIds(productIds).map(function (productId) {
      var url = getShopRoot() + "recommendations/products.json?product_id=" +
        encodeURIComponent(productId) + "&intent=" + encodeURIComponent(intent) +
        "&limit=" + encodeURIComponent(requestLimit);

      return fetch(url, {
        credentials: "same-origin",
        cache: "no-store"
      }).then(function (response) {
        return response.ok ? response.json() : { products: [] };
      }).then(function (data) {
        return data && Array.isArray(data.products) ? data.products : [];
      }).catch(function () {
        return [];
      });
    });

    return Promise.all(requests).then(function (groups) {
      return groups.reduce(function (products, group) {
        return products.concat(group);
      }, []);
    });
  }

  function filterProducts(products, excludedIds, limit) {
    var used = {};
    var excluded = {};

    excludedIds.forEach(function (id) {
      excluded[String(id)] = true;
    });

    return (products || []).filter(function (product) {
      if (!product || product.available === false || !product.id) return false;
      if (excluded[String(product.id)] || used[String(product.id)]) return false;
      used[String(product.id)] = true;
      return true;
    }).slice(0, limit);
  }

  function loadProducts(root, excludedIds) {
    var source = root.getAttribute("data-upsells-source") || "related";
    var fallbackRelated = root.getAttribute("data-upsells-fallback-related") === "true";
    var limit = parseInt(root.getAttribute("data-upsells-limit") || "3", 10);
    var productIds = uniqueIds(parseJson(root, "[data-upsells-product-ids]"));
    var configured = parseJson(root, "[data-upsells-configured-products]");
    var primaryPromise;

    if (source === "manual" || source === "metafield") {
      primaryPromise = Promise.resolve(configured);
    } else {
      primaryPromise = fetchRecommendations(productIds, source, limit);
    }

    return primaryPromise.then(function (products) {
      var filtered = filterProducts(products, excludedIds.concat(productIds), limit);
      if (filtered.length || !fallbackRelated || source === "related") return filtered;

      return fetchRecommendations(productIds, "related", limit).then(function (fallbackProducts) {
        return filterProducts(fallbackProducts, excludedIds.concat(productIds), limit);
      });
    });
  }

  function getProductImage(product) {
    var image = product.featured_image || (product.images && product.images[0]);
    if (typeof image === "string") return image;
    return image && image.src ? image.src : "";
  }

  function getAvailableVariant(product) {
    var variants = product.variants || [];
    for (var index = 0; index < variants.length; index += 1) {
      if (variants[index] && variants[index].available) return variants[index];
    }
    return variants[0] || null;
  }

  function getProductSubtitle(product) {
    var source = product.body_html || product.description || product.type || "";
    var temporary = document.createElement("div");
    temporary.innerHTML = source;
    var subtitle = (temporary.textContent || temporary.innerText || "").replace(/\s+/g, " ").trim();
    return subtitle.length > 80 ? subtitle.slice(0, 77).trim() + "…" : subtitle;
  }

  function buildCard(product, moneyFormat) {
    var variant = getAvailableVariant(product);
    var price = variant && variant.price != null ? variant.price : product.price;
    var compareAt = variant && variant.compare_at_price != null ? variant.compare_at_price : product.compare_at_price;
    var handle = product.handle || "";
    var productUrl = product.url || (handle ? getShopRoot() + "products/" + handle : "#");
    var imageUrl = getProductImage(product);
    var subtitle = getProductSubtitle(product);
    var priceHtml = "";
    var buttonHtml = "";

    if (compareAt && compareAt > price) {
      priceHtml = '<span class="custom-upsells__price--compare">' +
        formatMoney(compareAt, moneyFormat) + '</span><span class="custom-upsells__price--current">' +
        formatMoney(price, moneyFormat) + "</span>";
    } else {
      priceHtml = '<span class="custom-upsells__price--current">' + formatMoney(price, moneyFormat) + "</span>";
    }

    if (variant && variant.id && variant.available !== false) {
      buttonHtml = '<button type="button" class="custom-upsells__add" data-custom-upsell-add ' +
        'data-variant-id="' + escapeAttribute(variant.id) + '" aria-label="Add to cart">+</button>';
    }

    return '<div class="custom-upsells__slide">' +
      '<div class="custom-upsells__item">' +
        '<a class="custom-upsells__media" href="' + escapeAttribute(productUrl) + '">' +
          (imageUrl ? '<img src="' + escapeAttribute(imageUrl) + '" alt="' + escapeAttribute(product.title || "") + '" loading="lazy">' : "") +
        "</a>" +
        '<div class="custom-upsells__content">' +
          '<a class="custom-upsells__title" href="' + escapeAttribute(productUrl) + '">' + escapeHtml(product.title || "") + "</a>" +
          (subtitle ? '<div class="custom-upsells__subtitle">' + escapeHtml(subtitle) + "</div>" : "") +
          '<div class="custom-upsells__price">' + priceHtml + "</div>" +
          '<div class="custom-upsells__error" data-upsell-error hidden></div>' +
        "</div>" +
        buttonHtml +
      "</div>" +
    "</div>";
  }

  function destroySwiper(root) {
    if (root._customUpsellsSwiper && typeof root._customUpsellsSwiper.destroy === "function") {
      root._customUpsellsSwiper.destroy(true, true);
    }
    root._customUpsellsSwiper = null;
  }

  function initSwiper(root) {
    var slider = root.querySelector("[data-upsells-slider]");
    var layout = root.getAttribute("data-upsells-layout") || "slider";

    if (layout === "list") {
      destroySwiper(root);
      return;
    }

    if (!slider || !window.Swiper) return;

    destroySwiper(root);
    root._customUpsellsSwiper = new window.Swiper(slider, {
      wrapperClass: "custom-upsells__track",
      slideClass: "custom-upsells__slide",
      slideActiveClass: "custom-upsells__slide--active",
      slideNextClass: "custom-upsells__slide--next",
      slidePrevClass: "custom-upsells__slide--prev",
      slidesPerView: 1,
      spaceBetween: 10,
      speed: 300,
      watchOverflow: false,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: root.querySelector("[data-upsells-prev]"),
        nextEl: root.querySelector("[data-upsells-next]")
      }
    });
  }

  function renderRoot(root) {
    if (!root || root._customUpsellsLoading) return;
    var list = root.querySelector("[data-upsells-list]");
    if (!list) return;

    root._customUpsellsLoading = true;
    var moneyFormat = root.getAttribute("data-upsells-money-format") || "${{amount}}";

    fetchCart().then(function (cart) {
      if (root.getAttribute("data-upsells-mode") === "cart" && !(cart.items || []).length) {
        return [];
      }
      var excludedIds = (cart.items || []).map(function (item) { return item.product_id; });
      return loadProducts(root, excludedIds);
    }).then(function (products) {
      if (!document.documentElement.contains(root)) return;

      if (!products.length) {
        destroySwiper(root);
        list.innerHTML = "";
        root.setAttribute("data-upsells-status", "empty");
        return;
      }

      list.innerHTML = products.map(function (product) {
        return buildCard(product, moneyFormat);
      }).join("");
      root.setAttribute("data-upsells-status", "ready");
      initSwiper(root);
    }).catch(function () {
      root.setAttribute("data-upsells-status", "empty");
    }).then(function () {
      root._customUpsellsLoading = false;
    });
  }

  function renderAll() {
    document.querySelectorAll("[data-custom-upsells-root]").forEach(renderRoot);
  }

  function refreshCartUpsells() {
    var currentRoot = document.querySelector('.fixed-cart-wrap [data-custom-upsells-root][data-upsells-mode="cart"]');
    if (!currentRoot) {
      renderAll();
      return;
    }

    fetch(getShopRoot() + "?section_id=header-model-1", {
      credentials: "same-origin",
      cache: "no-store"
    }).then(function (response) {
      return response.ok ? response.text() : "";
    }).then(function (html) {
      if (!html) return;
      var parsed = new DOMParser().parseFromString(html, "text/html");
      var freshRoot = parsed.querySelector('[data-custom-upsells-root][data-upsells-mode="cart"]');
      if (!freshRoot || !document.documentElement.contains(currentRoot)) return;

      destroySwiper(currentRoot);
      currentRoot.replaceWith(freshRoot);
      renderRoot(freshRoot);

      document.querySelectorAll('[data-custom-upsells-root][data-upsells-mode="product"]').forEach(function (root) {
        root._customUpsellsLoading = false;
        renderRoot(root);
      });
    }).catch(renderAll);
  }

  function scheduleCartRefresh() {
    clearTimeout(cartRefreshTimer);
    cartRefreshTimer = setTimeout(refreshCartUpsells, 80);
  }

  function showCardError(button, message) {
    var item = button.closest(".custom-upsells__item");
    var error = item && item.querySelector("[data-upsell-error]");
    if (!error) return;
    error.textContent = message || "Could not add item";
    error.hidden = false;
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-custom-upsell-add]");
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    var variantId = button.getAttribute("data-variant-id");
    if (!variantId || button.disabled) return;

    button.disabled = true;
    button.classList.add("is-loading");

    fetch(getShopRoot() + "cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) throw data;
        return data;
      });
    }).then(function () {
      if (!window.open_cart_drawer_after_add) {
        window.dispatchEvent(new CustomEvent("theme:cart-refresh"));
      }
      scheduleCartRefresh();
    }).catch(function (error) {
      showCardError(button, error.description || error.message);
    }).then(function () {
      button.disabled = false;
      button.classList.remove("is-loading");
    });
  });

  window.addEventListener("theme:cart-updated", scheduleCartRefresh);
  window.addEventListener("theme:cart-added", scheduleCartRefresh);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", renderAll);
  } else {
    renderAll();
  }
})();
